import type { AdDto, AdListQuery, AdWriteInput, BulkActionInput, Paginated } from "@ads/shared";
import { apiJson } from "./client.js";

const JSON_HEADERS = { "Content-Type": "application/json" };

/** GET /api/orgs/:orgId/ads — default-ad listing for one org (server search/sort/paging, US-C1/C2). */
export function fetchAds(orgId: string, query: AdListQuery): Promise<Paginated<AdDto>> {
  const p = new URLSearchParams({
    page: String(query.page),
    limit: String(query.limit),
    order: query.order,
  });
  if (query.q) p.set("q", query.q);
  if (query.sort) p.set("sort", query.sort);
  return apiJson(`/api/orgs/${orgId}/ads?${p.toString()}`);
}

/** GET /api/ads/:id — one default ad (edit pre-fill, US-C3). */
export function fetchAd(id: string): Promise<AdDto> {
  return apiJson(`/api/ads/${id}`);
}

/** PATCH /api/ads/:id/status — single active/inactive toggle (US-F1). */
export function setAdStatus(id: string, status: 0 | 1): Promise<AdDto> {
  return apiJson(`/api/ads/${id}/status`, {
    method: "PATCH",
    headers: JSON_HEADERS,
    body: JSON.stringify({ status }),
  });
}

/** POST /api/ads/bulk-action — activate/deactivate/delete the selected ads (US-F2). */
export function bulkAdAction(input: BulkActionInput): Promise<{ affected: number }> {
  return apiJson(`/api/ads/bulk-action`, {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify(input),
  });
}

/** POST /api/ads — create a default ad across the targeted orgs (US-D1/D5). */
export function createAd(input: AdWriteInput): Promise<AdDto> {
  return apiJson(`/api/ads`, { method: "POST", headers: JSON_HEADERS, body: JSON.stringify(input) });
}

/** PUT /api/ads/:id — edit a default ad (US-E1/E2). */
export function updateAd(id: string, input: AdWriteInput): Promise<AdDto> {
  return apiJson(`/api/ads/${id}`, { method: "PUT", headers: JSON_HEADERS, body: JSON.stringify(input) });
}
